import { useEffect } from 'react';
import type { SelectedWorkflow } from 'src/context/ConfigurationContext';
import type { Workflow } from 'src/pages/ConfigurationPage/WorkflowsTab/workflowFormValues';
import type { ConfigurationFormFieldsObject } from 'src/pages/ConfigurationPage/hooks/useConfigurationFormFields';
import type { ConfigurationFormMethods } from 'src/pages/ConfigurationPage/hooks/useConfigurationForm';
import {
  getPersonaFormValues,
  type PersonaInputData,
} from 'src/pages/ConfigurationPage/utils/getPersonaFormValues';

// Whenever the page (re)enters readonly mode - on mount, after cancel, or
// after a successful save - snaps the form and workflow selections back to
// the active version's canonical values.
export const useResetFormOnReadonlyChange = ({
  readonly,
  methods,
  inputData,
  formFieldsObject,
  setDefaultWorkflows,
  setCustomWorkflows,
  setIsEditWorkflowMode,
  setSelectedWorkflow,
}: {
  readonly: boolean;
  methods: ConfigurationFormMethods;
  inputData: PersonaInputData | null;
  formFieldsObject: ConfigurationFormFieldsObject;
  setDefaultWorkflows: (workflows: Workflow[]) => void;
  setCustomWorkflows: (workflows: Workflow[]) => void;
  setIsEditWorkflowMode: (value: boolean) => void;
  setSelectedWorkflow: (value: SelectedWorkflow | null) => void;
}) => {
  useEffect(() => {
    if (!readonly) {
      return;
    }

    methods.reset(getPersonaFormValues(inputData, formFieldsObject));

    setDefaultWorkflows(inputData?.pf_default_workflow ? [inputData.pf_default_workflow] : []);
    setCustomWorkflows(inputData?.pf_custom_workflows || []);
    setIsEditWorkflowMode(false);
    setSelectedWorkflow(null);
  }, [readonly]);
};
